import RestRequestFactory from '@core/utils/network/RestRequestFactory';
import * as enums from '@core/services/offer/_private/models/enums';
import OfferRequest from '@core/services/offer/_private/models/OfferRequest';
import EventMapper from '@core/mappers/offer/EventMapper';

export default class RestService {
    private readonly request: any;

    constructor(
        hostServer: string,
        restRequestFactory = RestRequestFactory,
        private readonly eventMapper = new EventMapper()) {

        this.request = restRequestFactory.create(hostServer);
    }

    /**
     * @throws {RequestError}
     */
    public getStruct(): Promise<any> {
        return this.request({
            url: '/offer/getOfferStruct',
            method: 'get',
            params: {
                controller: enums.OfferController.offer,
                method: enums.OfferMethods.struct,
                compression: 1
            }
        });
    }

    /**
     * @throws {RequestError}
     */
    public getEvents(startDate: Date, endDate: Date): Promise<any> {
        return this.request({
            url: '/offer/getOfferByDate',
            method: 'get',
            params: OfferRequest.createAllEventsRequest(startDate, endDate)
        });
    }

    /**
     * @throws {RequestError}
     */
    public getOutrights(): Promise<any> {
        return this.request({
            url: '/offer/outrights',
            method: 'get',
        });
    }

    public getLiveEvents(startDate: Date): Promise<any> {
        return this.request({
            url: '/offer/getOfferByDate',
            method: 'get',
            params: OfferRequest.createSocketLiveEventsRequest(startDate)
        });
    }

    /**
     * @throws {RequestError}
     */
    public getEventsBySport(sportId: number, startDate: Date, endDate: Date): Promise<any> {
        return this.request({
            url: '/offer/getOfferByDate',
            method: 'get',
            params: OfferRequest.createSportRequest(sportId, startDate, endDate)
        });
    }

    /**
     * @throws {RequestError}
     */
    public getEventsByTournament(tournamentId: number, startDate: Date, endDate: Date): Promise<any> {
        return this.request({
            url: '/offer/getOfferByDate',
            method: 'get',
            params: OfferRequest.createTournamentRequest(tournamentId, startDate, endDate)
        });
    }

    /**
     * @throws {RequestError}
     */
    public getSuperEvents(startDate: Date, endDate: Date): Promise<any> {
        return this.request({
            url: '/offer/getSuperOfferByDate',
            method: 'get',
            params: OfferRequest.createSuperOfferRequest(startDate, endDate)
        });
    }

    /**
     * @throws {RequestError}
     */
    public getTopTenEvents(): Promise<any> {
        return this.request({
            url: '/offer/getTopTenOffer',
            method: 'get',
            params: OfferRequest.createTopTenRequest()
        });
    }

    /**
     * @throws {RequestError}
     */
    public getSportsTrees(startDate: Date): Promise<any> {
        return this.request({
            url: '/offer/getSportsTree',
            method: 'get',
            params: OfferRequest.createSportsTreeRequest(startDate)
        });
    }

    /**
     * @throws {RequestError}
     */
    public async getEventsById(eventIds: number[]): Promise<any> {
        const response = await this.request.get('/matches/byId', {
            params: OfferRequest.createEventsByIdRequest(eventIds)
        });
        return response.data.map((e: any) => this.eventMapper.createTargetObject(e));
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/services/offer/_private/RestService.ts